import React, { useEffect, useRef } from 'react';
import './App.scss';
import Header from './components/common-header/Header';
import Footer from './components/common-footer/Footer';
import Hero from './components/Hero/Hero';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Section1 from './components/Sections/Section1';
import Section2 from './components/Sections/Section2';
import Section3 from './components/Sections/Section3';
import Section4 from './components/Sections/Section4';

import inline1D from './assets/inline1D.jpg';
import inline1M from './assets/inline1M.jpg';
import inline2D from './assets/inline2D.jpg';
import inline2M from './assets/inline2M.jpg';
import inline3D from './assets/inline3D.jpg';
import inline3M from './assets/inline3M.jpg';
import { WidthContextProvider } from './WidthContext';
import ctaArrow from './assets/arrow.svg';
import Factbox from './components/Factbox/Factbox';
import CampaignFooter from './components/campaignFooter/CampaignFooter';
gsap.registerPlugin(ScrollTrigger);

function App() {
  const section1 = useRef();
  const section2 = useRef();
  const section3 = useRef();
  const section4 = useRef();

  const inline1 = useRef();
  const inline2 = useRef();
  const inline3 = useRef();
  const inline4 = useRef();
  const headerRef = useRef();

  useEffect(() => {
    const inlines = [inline1, inline2, inline3, inline4];
    let ctx = gsap.context(() => {
      inlines.forEach((panel, i) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: panel.current,
            start: '10% bottom',
            end: 'top center',
            scrub: 1,
            once: true
          }
        });
        tl.to(panel.current, { width: '100%', duration: 3, ease: 'linear' });
      });
    });
    return () => ctx.revert();
  }, []);

  useEffect(() => {
    let ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: headerRef.current,
          start: 'bottom top',
          scrub: 1
        }
      });
      tl.to(headerRef.current, { y: '-64px', duration: 1.5 });
    });
    return () => ctx.revert();
  }, []);

  return (
    <WidthContextProvider>
      <div className="App">
        <div className="section" ref={section1}>
          <Header headerRef={headerRef} clientName={"National Association of REALTORS®"}/>
          <Hero />
          <Section1 />
        </div>

        <div className="section" ref={section2}>
          <div className="inline">
            <picture className="inline-photo" ref={inline1}>
              <source media="(min-width:461px)" srcSet={inline1D} />
              <source media="(max-width:460px)" srcSet={inline1M} />
              <img src={inline1D} alt="Family" />
            </picture>
          </div>
          <Section2 />
        </div>
        <div className="section" ref={section3}>
          <div className="inline">
            <picture className="inline-photo" ref={inline2}>
              <source media="(min-width:461px)" srcSet={inline2D} />
              <source media="(max-width:460px)" srcSet={inline2M} />
              <img src={inline2D} alt="Family" />
            </picture>
          </div>
          <Section3 />
        </div>
        <div className="section" ref={section4}>
          <div className="inline">
            <picture className="inline-photo" ref={inline3}>
              <source media="(min-width:461px)" srcSet={inline3D} />
              <source media="(max-width:460px)" srcSet={inline3M} />
              <img src={inline3D} alt="Family" />
            </picture>
          </div>
          <Section4 />
          <Factbox />
          <a
            href="https://www.realtor.com/thats-who-we-r/"
            target="_blank"
            rel="sponsored noopener"
            className="nar-href nar"
          >
            <div className="nar-href-button">
              Learn More <img src={ctaArrow} alt="arrow" className="nar-href-arrow" />
            </div>
          </a>
          <CampaignFooter />
          <Footer />
        </div>
      </div>
    </WidthContextProvider>
  );
}

export default App;
